import Vue from 'vue'
import Router from 'vue-router'
import RouteView from '@/layouts/RouteView'
import MenuView from '@/layouts/MenuView'
import Login from '@/pages/login/Login'

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
}
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
}
Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: '首页',
      component: MenuView,
      redirect: '/workspace',
      icon: 'none',
      invisible: true,
      children: [
        {
          name: '概览',
          path: '/workspace',
          component: resolve => require(['@/pages/workspace/firstspace.vue'], resolve),
          icon: 'fund'
        },
        {
          path: '/merchantManage/merchantList',
          name: '应用管理',
          component: resolve => require(['@/pages/merchantManage/merchantList.vue'], resolve),
          icon: 'gateway',
        },
        {
          path: '/merchantManage/merchantDetails',
          name: '应用详情',
          invisible: true,
          component: resolve => require(['@/pages/merchantManage/detail/merchantDetails.vue'], resolve),
          icon: ''
        },
        {
          path: '/merchantManage/roleManagement',
          name: '权限管理',
          invisible: true,
          component: resolve => require(['@/pages/merchantManage/roleManagement.vue'], resolve),
          icon: ''
        },
        {
          path: '/serviceManage/serviceList',
          name: '服务管理',
          component: resolve => require(['@/pages/serviceManage/serviceList.vue'], resolve),
          icon: 'cluster',
        },
        {
          path: '/dashboard',
          name: '用户管理',
          component: RouteView,
          icon: 'user',
          children: [
            {
              path: '/dashboard/BUserList',
              name: 'B端用户',
              component: resolve => require(['@/pages/dashboard/BUserList.vue'], resolve),
              icon: ''
            },
            {
              path: '/dashboard/CUserList',
              name: 'C端用户',
              component: resolve => require(['@/pages/dashboard/CUserList.vue'], resolve),
              icon: ''
            },
          ]
        },
        {
          path: '/logManage',
          name: '日志管理',
          component: RouteView,
          icon: 'schedule',
          children: [
            {
              path: '/logManage/APIlogs',
              name: 'API请求日志',
              component: resolve => require(['@/pages/logManage/APIlogs.vue'], resolve),
              icon: ''
            },
            {
              path: '/logManage/logrecord',
              name: '常规日志记录',
              component: resolve => require(['@/pages/logManage/LogRecord.vue'], resolve),
              icon: ''
            },
            {
              path: '/logManage/gateway',
              name: '医疗服务网关日志',
              component: resolve => require(['@/pages/logManage/GatewayLog'], resolve),
              icon: ''
            },
            {
              path: '/logManage/sqllogs',
              name: '数据库日志',
              component: resolve => require(['@/pages/logManage/Sqllogs.vue'], resolve),
              icon: ''
            },
            {
              path: '/logManage/wechat',
              name: '微信网关消息',
              component: resolve => require(['@/pages/logManage/Wechat.vue'], resolve),
              icon: ''
            }
          ]
        },
        {
          name: '系统设置',
          path: '/systemSetting',
          component: RouteView,
          icon: 'setting',
          children: [
            // {
            //   path: '/systemSetting/contactUsers',
            //   name: '通讯录',
            //   component: resolve => require(['@/pages/systemSetting/contactUsers.vue'], resolve),
            //   icon: ''
            // },
            // {
            //   path: '/systemSetting/productService',
            //   name: '产品维护',
            //   component: resolve => require(['@/pages/systemSetting/productService.vue'], resolve),
            //   icon: ''
            // },
            {
              path: '/corpManage/corpList',
              name: '合作商设置',
              component: resolve => require(['@/pages/corpManage/corpList.vue'], resolve),
              icon: ''
            },
            {
              path: '/corpManage/corpDetail',
              name: '合作商详情',
              invisible: true,
              component: resolve => require(['@/pages/corpManage/corpDetail.vue'], resolve),
              icon: ''
            },
            {
              path: '/serviceManage/corpList',
              name: '服务商设置',
              component: resolve => require(['@/pages/serviceManage/corpList.vue'], resolve),
              icon: ''
            },
            {
              path: '/systemSetting/configManage',
              name: '配置管理',
              component: resolve => require(['@/pages/systemSetting/configManage.vue'], resolve),
              icon: ''
            },
            // {
            //   path: '/systemSetting/userRoles',
            //   name: '角色权限',
            //   component: resolve => require(['@/pages/systemSetting/userRoles.vue'], resolve),
            //   icon: ''
            // }
          ]
        },
        {
          name: '文档中心',
          path: '/doc',
          component: RouteView,
          icon: 'form',
          children: [
            {
              path: '/doc/baseService',
              name: '基础服务',
              component: resolve => require(['@/pages/doc/Baseservice.vue'], resolve),
              icon: ''
            },
            {
              path: '/doc/bizService',
              name: '业务服务',
              component: resolve => require(['@/pages/doc/Bizservice.vue'], resolve),
              icon: ''
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: '登录页',
      component: Login,
      invisible: true,
    }
  ]
});

router.beforeEach((to, from, next) => {
  let isLogin = localStorage.getItem('LOGIN_ACCESS_TOKEN')
  if (!isLogin && to.path !== '/login') {
    router.push({path: '/login'})
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js